import { Button, Group, NumberInput, Select, Text } from "@mantine/core"
import React from "react"

const PER_PAGE_OPTIONS = ['10', '20', '30', '50', '100']

const selectGroupStyle = {
  borderRight: '1px solid #ccc',
  paddingRight: 16,
}

interface Props {
  page: number
  onChangePage: (page: number) => void
  perPage: number
  onChangePerPage: (perPage: number) => void
  totalPages: number

  /** 0件のときだけテーブルとの境界線を出す */
  isEmpty: boolean
}

export const TablePagination: React.FC<Props> = ({
  page,
  onChangePage,
  perPage,
  onChangePerPage,
  totalPages,
  isEmpty,
}) => {
  const handleChangePerPage = (value: string | null) => {
    if (value !== null) onChangePerPage(Number(value))
  }

  // ページ番号入力 Enter で確定
  const handleKeyDownPage = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return
    const next = parseInt(event.currentTarget.value, 10)
    if (Number.isNaN(next)) return
    onChangePage(Math.max(1, Math.min(totalPages, next)))
  }

  return (
    <Group
      justify="end"
      p="sm"
      bg="#00000008"
      style={{borderTop: isEmpty ? '1px solid var(--mantine-color-gray-3)' : undefined}}
    >
      <Group style={selectGroupStyle}>
        <Select
          value={perPage.toString()}
          data={PER_PAGE_OPTIONS}
          onChange={handleChangePerPage}
          allowDeselect={false}
          w={75}
          checkIconPosition="right"
        />
        <Text>行表示中</Text>
      </Group>

      <Group>
        <Group gap={8}>
          <Text>ページ：</Text>
          <NumberInput
            value={page}
            allowDecimal={false}
            allowNegative={false}
            clampBehavior="strict"
            min={1}
            max={totalPages}
            onKeyDown={handleKeyDownPage}
            w={50}
            styles={{input: {textAlign: 'right'}}}
            hideControls
          />
          <Text> / {totalPages}</Text>
        </Group>

        <Button
          variant="outline"
          onClick={() => onChangePage(page - 1)}
          disabled={page === 1}
          radius="xl"
        >
          前へ
        </Button>

        <Button
          variant="outline"
          onClick={() => onChangePage(page + 1)}
          disabled={page >= totalPages}
          radius="xl"
        >
          次へ
        </Button>
      </Group>
    </Group>
  )
}
